import {useSelector} from "react-redux";

import {IRPStore} from "../../app/rp_reducer";
import {getPhoneDataFromString} from "../../form/utils/get_phone_data_from_string";
import {getBudgetFilterDefaultValues} from "../../real_estate/utils/get_budget_filter_default_values";
import {IRegionListRegion} from "../../search/actions/fetch_search_regions_action";
import {BudgetFieldsNames} from "../../search/components/generic_filters/FilterBudget";
import {ForYouRegionType} from "../types/ForYouRegionType";
import {IForYouAdditional} from "../types/IForYouAdditional";
import {IForYouCriteria} from "../types/IForYouCriteria";
import {IForYouUser} from "../types/IForYouUser";

export interface IDefaultForYouFormValues extends IForYouCriteria, IForYouUser, IForYouAdditional {
    region: ForYouRegionType;
    [BudgetFieldsNames.TOTAL]: number;
    [BudgetFieldsNames.CREDIT]: number;
    [BudgetFieldsNames.RADIO]: string;
}

export const useDefaultForYouValues = (availableRegions?: IRegionListRegion[]): IDefaultForYouFormValues => {
    const searchFormValues = useSelector((state: IRPStore) => state.search.formValues);
    const userProfile = useSelector((state: IRPStore) => state.user.profile);
    const phone = userProfile.data?.phone;

    const defaultValues: IDefaultForYouFormValues = {
        region: {label: "Wybierz miasto", value: 0},
        rooms: searchFormValues.rooms || {upper: 0, lower: 0},
        area: {upper: parseInt(searchFormValues.area.upper) || 65, lower: parseInt(searchFormValues.area.lower) || 44},
        ...getBudgetFilterDefaultValues(searchFormValues),
        name: userProfile.data?.name || null,
        email: userProfile.data?.email || null,
        phone: phone ? getPhoneDataFromString(phone) : null,
        propertyNotification: true,
        financigServices: false,
        additional_areas: "",
        kitchen: "",
        floor: [],
        date: searchFormValues.construction_end_date?.[0]?.toString() || "",
        quarters: null,
        message: null
    };

    const regions = searchFormValues.search.regions?.reduce((acc: IRegionListRegion[], region: IRegionListRegion) => {
        const availableRegion = availableRegions?.find((city) => city.id === region.id);
        const availableParent = availableRegions?.find((city) => city.id === region.parent?.id);

        if (availableRegion) {
            return [...acc, availableRegion];
        }

        if (!availableRegion && availableParent) {
            return [...acc, availableParent];
        }

        return acc;
    }, []);

    const areRegionsSame = regions?.every((region: IRegionListRegion, _: number, allRegions: IRegionListRegion[]) => region.id === allRegions[0].id);

    if (regions?.length && areRegionsSame) {
        defaultValues.region = {label: regions[0].name, value: regions[0].id};
    }

    return defaultValues;
};
import {useSelector} from "react-redux";

import {IRPStore} from "../../app/rp_reducer";
import {getPhoneDataFromString} from "../../form/utils/get_phone_data_from_string";
import {getBudgetFilterDefaultValues} from "../../real_estate/utils/get_budget_filter_default_values";
import {IRegionListRegion} from "../../search/actions/fetch_search_regions_action";
import {BudgetFieldsNames} from "../../search/components/generic_filters/FilterBudget";
import {ForYouRegionType} from "../types/ForYouRegionType";
import {IForYouAdditional} from "../types/IForYouAdditional";
import {IForYouCriteria} from "../types/IForYouCriteria";
import {IForYouUser} from "../types/IForYouUser";

export interface IDefaultForYouFormValues extends IForYouCriteria, IForYouUser, IForYouAdditional {
    region: ForYouRegionType;
    [BudgetFieldsNames.TOTAL]: number;
    [BudgetFieldsNames.CREDIT]: number;
    [BudgetFieldsNames.RADIO]: string;
}

export const useDefaultForYouValues = (availableRegions?: IRegionListRegion[]): IDefaultForYouFormValues => {
    const searchFormValues = useSelector((state: IRPStore) => state.search.formValues);
    const userProfile = useSelector((state: IRPStore) => state.user.profile);
    const phone = userProfile.data?.phone;

    const defaultValues: IDefaultForYouFormValues = {
        region: {label: "Wybierz miasto", value: 0},
        rooms: searchFormValues.rooms || {upper: 0, lower: 0},
        area: {upper: parseInt(searchFormValues.area.upper) || 65, lower: parseInt(searchFormValues.area.lower) || 44},
        ...getBudgetFilterDefaultValues(searchFormValues),
        name: userProfile.data?.name || null,
        email: userProfile.data?.email || null,
        phone: phone ? getPhoneDataFromString(phone) : null,
        propertyNotification: true,
        financigServices: false,
        additional_areas: "",
        kitchen: "",
        floor: [],
        date: searchFormValues.construction_end_date?.[0]?.toString() || "",
        quarters: null,
        message: null
    };

    const regions = searchFormValues.search.regions?.reduce((acc: IRegionListRegion[], region: IRegionListRegion) => {
        const availableRegion = availableRegions?.find((city) => city.id === region.id);
        const availableParent = availableRegions?.find((city) => city.id === region.parent?.id);

        if (availableRegion) {
            return [...acc, availableRegion];
        }

        if (!availableRegion && availableParent) {
            return [...acc, availableParent];
        }

        return acc;
    }, []);

    const areRegionsSame = regions?.every((region: IRegionListRegion, _: number, allRegions: IRegionListRegion[]) => region.id === allRegions[0].id);

    if (regions?.length && areRegionsSame) {
        defaultValues.region = {label: regions[0].name, value: regions[0].id};
    }

    return defaultValues;
};
